import type { NextPage } from 'next'
import Head from 'next/head'

interface IProps {
  title?: string
  description?: string
  author?: string
  keywords?: string
}

const Component: NextPage<IProps> = ({ title, description, author, keywords }) => {
  const titleItems = []
  title && titleItems.push(title)
  titleItems.push(process.env.SERVICE_NAME || process.env.NEXT_PUBLIC_SERVICE_NAME)
  const companyName = process.env.COMPANY_NAME || process.env.NEXT_PUBLIC_COMPANY_NAME || ''
  const serviceUrl = process.env.SERVICE_URL || process.env.NEXT_PUBLIC_SERVICE_URL || ''

  return (
    <Head>
      <title>{titleItems.join(' :: ')}</title>
      {description && <meta name="description" content={description} />}
      {author && <meta name="author" content={author} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {companyName && <meta name="copyright" content={`© ${companyName} All Rights Reserved.`} />}
      {companyName && <meta name="author" content={companyName} />}
      <meta property="og:title" content={titleItems.join(' :: ')} />
      <meta property="og:url" content={serviceUrl} />
      <meta property="og:image" content={`${serviceUrl}/images/logo-fulltext.png`} />
      {description && <meta property="og:description" content={description} />}
    </Head>
  )
}

export default Component
